common.View.create('website::layouts.main.BurgerMenu', {

    currentColor: 'bg-palette-gray',

    onDOMLoad()
    {
        this.initBurgerMenu();
        this.initCloseBurgerMenu();
        this.initVacancyHover();
    },

    initVacancyHover() {
        const vacancy = this.element.find('.vacancy-nav-item');
        let originalLogoSrc = '';
        let originalColor = '';
        const logo = $('.vacancyMenuLogo');
        const background = $('.vacancyBackground');

        if (originalLogoSrc === '') {
            originalLogoSrc = logo.attr('src'); // Set original logo source only once
        }

        if (!originalColor) {
            originalColor = background.attr('class').split(' ').find(cls => cls.startsWith('bg-palette-'));
        }

        this.currentColor = originalColor;

        vacancy.on('mouseover', (event) => {
            const newLogoSrc = '/img/website/' + $(event.currentTarget).data('vacancy-type-logo');
            const newColor = $(event.currentTarget).data('vacancy-background');

            if(this.mouseLeaveTimeout)
                clearTimeout(this.mouseLeaveTimeout);

            if (newColor != this.currentColor) {

                this.currentColor = newColor;

                logo.stop().fadeOut(150, function () {

                    background.removeClass(function (index, className) {
                        return (className.match(/(^|\s)bg-palette-\S+/g) || []).join(' ');
                    }).addClass(newColor);

                    logo.attr('src', newLogoSrc);
                    logo.stop().fadeIn(150);
                });
            }
        });

        vacancy.on('mouseleave', (event) => {

            if(this.mouseLeaveTimeout)
                clearTimeout(this.mouseLeaveTimeout);

            this.mouseLeaveTimeout = setTimeout(() => {
                if (this.currentColor != 'bg-palette-gray') {

                    this.currentColor = originalColor;

                    logo.stop().fadeOut(150, ()=>  {

                        background.removeClass(function (index, className) {
                            return (className.match(/(^|\s)bg-palette-\S+/g) || []).join(' ');
                        }).addClass(originalColor);

                        logo.attr('src', originalLogoSrc);
                        logo.stop().fadeIn(150);
                    });
                }
            }, 1);
        });
    },

    initBurgerMenu() {
        this.element.find('.burgerMenu')
            .on('click', (event) => {
                // Set as active
                $(event.currentTarget).toggleClass('is-active');

                // Fade menu
                this.element.find('.trigger').fadeIn('fast');
            });
    },

    initCloseBurgerMenu() {
        this.element.find('.closeBurgerMenu')
            .on('click', () => {
                // Remove active
                $('.burgerMenu').removeClass('is-active');

                // Fade menu
                this.element.find('.trigger').fadeOut('fast');
            });
    },

});
